// src/pages/about/AboutPage.jsx
import React, { useState, useEffect } from 'react';
import './AboutPage.css';

const AboutPage = () => {
  const [settings, setSettings] = useState({
    about_hero_title: 'About Us',
    about_hero_subtitle: 'Learn more about our story and mission',
    about_story_title: 'Our Story',
    about_story_text: '',
    about_story_image: '',
    about_mission_title: 'Our Mission',
    about_mission_text: '',
    about_mission_image: '',
    about_team_title: 'Our Team',
    about_team_member_1_name: '',
    about_team_member_1_role: '',
    about_team_member_1_image: '',
    about_team_member_2_name: '',
    about_team_member_2_role: '',
    about_team_member_2_image: '',
    about_team_member_3_name: '',
    about_team_member_3_role: '',
    about_team_member_3_image: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(prev => ({ ...prev, ...data.settings }));
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const teamMembers = [
    { num: 1, name: settings.about_team_member_1_name, role: settings.about_team_member_1_role, image: settings.about_team_member_1_image },
    { num: 2, name: settings.about_team_member_2_name, role: settings.about_team_member_2_role, image: settings.about_team_member_2_image },
    { num: 3, name: settings.about_team_member_3_name, role: settings.about_team_member_3_role, image: settings.about_team_member_3_image }
  ];

  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="about-page">
      <div className="about-header">
        <h1>{settings.about_hero_title}</h1>
        <p>{settings.about_hero_subtitle}</p>
      </div>

      <div className="about-content">
        {/* Our Story Section */}
        <div className="about-section story-section">
          <div className="text-column fade-in-left">
            <h2>{settings.about_story_title}</h2>
            <p>{settings.about_story_text}</p>
          </div>
          <div className="image-column fade-in-right">
            <img src={settings.about_story_image} alt="Our Story" />
          </div>
        </div>

        {/* Our Mission Section */}
        <div className="about-section mission-section">
          <div className="image-column fade-in-left">
            <img src={settings.about_mission_image} alt="Our Mission" />
          </div>
          <div className="text-column fade-in-right">
            <h2>{settings.about_mission_title}</h2>
            <p>{settings.about_mission_text}</p>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="about-section features-section">
          <h2>Why Choose Us?</h2>
          <div className="features-list">
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div>
                <h3>Quality Guaranteed</h3>
                <p>All products are thoroughly tested and approved</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div>
                <h3>Secure Shopping</h3>
                <p>Your privacy and security is our top priority</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div>
                <h3>Fast Shipping</h3>
                <p>Quick and reliable delivery worldwide</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">✓</div>
              <div>
                <h3>24/7 Support</h3>
                <p>Our customer service team is always here to help</p>
              </div>
            </div>
          </div>
        </div>

        {/* Our Team Section */}
        <div className="about-section team-section">
          <h2>{settings.about_team_title}</h2>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              member.name && (
                <div key={index} className="team-member">
                  <div className="team-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <h3>{member.name}</h3>
                  <p>{member.role}</p>
                </div>
              )
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;